export function normalizeForSearch(text) {
    return text
        .normalize('NFD')
        .replace(/\p{M}/gu, '')
        .toLowerCase()
        .replace(/\s+/g, ' ');
}
export function textIncludesQuery(haystack, query) {
    const normalizedQuery = normalizeForSearch(query.trim());
    if (!normalizedQuery) {
        return true;
    }
    return normalizeForSearch(haystack).includes(normalizedQuery);
}
export function textsEqualForSearch(a, b) {
    return normalizeForSearch(a) === normalizeForSearch(b);
}
const BASE_LETTER_VARIANTS = {
    a: 'aáàäâãåāăą',
    e: 'eéèëêēėęě',
    i: 'iíìïîīįı',
    o: 'oóòöôõøōő',
    u: 'uúùüûūůű',
    y: 'yýÿŷ',
    n: 'nñńņň',
    c: 'cçćč',
    s: 'sśšşß',
    z: 'zźżž',
    d: 'dďđ',
    l: 'lĺľł',
    r: 'rŕř',
    t: 'tţť',
    g: 'gğĝ',
};
function escapeRegExp(text) {
    return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
function escapeCharClass(chars) {
    return chars.replace(/[\\\]^-]/g, '\\$&');
}
export function toDiacriticInsensitiveRegExpSource(query) {
    return Array.from(normalizeForSearch(query))
        .map((char) => {
        const variants = BASE_LETTER_VARIANTS[char];
        if (variants) {
            return `[${escapeCharClass(variants)}]\\p{M}*`;
        }
        return `${escapeRegExp(char)}\\p{M}*`;
    })
        .join('');
}
function isSearchWhitespace(char) {
    return /\s/.test(char);
}
function buildFoldMap(text) {
    let folded = '';
    const toOriginal = [];
    for (let i = 0; i < text.length;) {
        const codePoint = text.codePointAt(i);
        const char = String.fromCodePoint(codePoint);
        if (isSearchWhitespace(char)) {
            if (!folded.endsWith(' ')) {
                toOriginal.push(i);
                folded += ' ';
            }
            i += char.length;
            continue;
        }
        const foldedChar = char.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase();
        for (let j = 0; j < foldedChar.length; j++) {
            toOriginal.push(i);
            folded += foldedChar[j];
        }
        i += char.length;
    }
    return { folded, toOriginal };
}
function foldedMatchEndOriginal(text, originalStart, foldedLength) {
    let foldedConsumed = 0;
    let i = originalStart;
    while (i < text.length && foldedConsumed < foldedLength) {
        const codePoint = text.codePointAt(i);
        const char = String.fromCodePoint(codePoint);
        if (isSearchWhitespace(char)) {
            while (i < text.length) {
                const whitespaceCodePoint = text.codePointAt(i);
                const whitespaceChar = String.fromCodePoint(whitespaceCodePoint);
                if (!isSearchWhitespace(whitespaceChar)) {
                    break;
                }
                i += whitespaceChar.length;
            }
            foldedConsumed += 1;
            continue;
        }
        const foldedChar = char.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase();
        foldedConsumed += foldedChar.length;
        i += char.length;
    }
    return i;
}
export function findAllFoldedSubstringRanges(haystack, query) {
    const foldedQuery = normalizeForSearch(query);
    if (!foldedQuery) {
        return [];
    }
    const { folded, toOriginal } = buildFoldMap(haystack);
    const ranges = [];
    let from = 0;
    while (from <= folded.length) {
        const idx = folded.indexOf(foldedQuery, from);
        if (idx === -1) {
            break;
        }
        const start = toOriginal[idx];
        const end = foldedMatchEndOriginal(haystack, start, foldedQuery.length);
        ranges.push({ start, end });
        from = idx + 1;
    }
    return ranges;
}
//# sourceMappingURL=text-search.js.map